/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Type_LabelInputs */

const fr_vehicle_action_edit_type_label = /** @type {(inputs: Vehicle_Action_Edit_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de véhicule`)
};

const en_vehicle_action_edit_type_label = /** @type {(inputs: Vehicle_Action_Edit_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle type`)
};

/**
* | output |
* | --- |
* | "Vehicle type" |
*
* @param {Vehicle_Action_Edit_Type_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_type_label = /** @type {((inputs?: Vehicle_Action_Edit_Type_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Type_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_type_label(inputs)
	return en_vehicle_action_edit_type_label(inputs)
});